import script from "./NewClaimYouTubeUrlInputNew.vue?vue&type=script&setup=true&lang=js"
export * from "./NewClaimYouTubeUrlInputNew.vue?vue&type=script&setup=true&lang=js"

import "./NewClaimYouTubeUrlInputNew.vue?vue&type=style&index=0&id=6be4f041&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6be4f041"]])

export default __exports__